export const ROUTES_WITHOUT_SIDE_NAV = [
  '/login',
  '/signup',
  '/reset',
  '/reset-sent',
  '/resetverify',
  '/multifactor-authentication',
  '/recover-account',
]
